import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { extApi } from '../api/extensibilityClient';

export function ModelLibraryPage() {
  const [lib, setLib] = useState<any>(null);

  useEffect(() => { extApi.modelLibrary().then(setLib).catch(console.error); }, []);

  if (!lib) return <div className="loading">Loading model library…</div>;

  return (
    <div>
      <h1 className="page-title">Model Library</h1>
      <p className="page-subtitle">Main model, sub-models, actions, and user-defined extensions.</p>

      <div className="card">
        <h3>{lib.main_model.name}</h3>
        <p style={{ fontSize: '0.85rem', color: '#6b7280' }}>Workbook-faithful V1.5 baseline · Active</p>
      </div>

      <div className="card">
        <h3>Sub-Models ({lib.sub_models.length})</h3>
        {lib.sub_models.length === 0 ? <p style={{ fontSize: '0.85rem' }}>No sub-models yet. <Link to="/sub-model-builder">Create one</Link></p> : (
          <table className="data-table">
            <thead><tr><th>Name</th><th>Active</th><th>Output</th><th>Version</th></tr></thead>
            <tbody>
              {lib.sub_models.map((m: any) => (
                <tr key={m.id}><td>{m.name}</td><td>{m.active ? 'Yes' : 'No'}</td><td>{m.output_variable_id || '—'}</td><td>{m.current_version}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="card">
        <h3>Actions ({lib.actions.length})</h3>
        {lib.actions.length === 0 ? <p style={{ fontSize: '0.85rem' }}>No actions yet. <Link to="/actions">Create one</Link></p> : (
          <table className="data-table">
            <thead><tr><th>Name</th><th>Entity</th><th>Status</th><th>Output variable</th></tr></thead>
            <tbody>
              {lib.actions.map((a: any) => (
                <tr key={a.id}><td>{a.name}</td><td>{a.responsible_entity}</td><td>{a.status}</td><td>{a.output_variable_id || '—'}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="card">
        <h3>User-Defined Variables ({lib.user_variables.length})</h3>
        <table className="data-table">
          <thead><tr><th>ID</th><th>Name</th><th>Area</th><th>GDP linked</th></tr></thead>
          <tbody>
            {lib.user_variables.map((v: any) => (
              <tr key={v.id}><td>{v.id}</td><td>{v.name}</td><td>{v.policy_area_name}</td><td>{v.gdp_link_active ? 'Yes' : 'No'}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
